export default __webpack_public_path__ + "static/media/User.27556777.svg";